var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("select", {
    staticClass: "selectize selectize-single",
    attrs: {
      name: _vm.name,
      id: _vm.name,
      placeholder: _vm.placeholder,
      disabled: _vm.disabled,
      multiple: "",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }